import { render, staticRenderFns } from "./interactpage.vue?vue&type=template&id=6565b3c4&scoped=true&"
import script from "./interactpage.vue?vue&type=script&scoped=scoped&lang=js&"
export * from "./interactpage.vue?vue&type=script&scoped=scoped&lang=js&"
import style0 from "./interactpage.vue?vue&type=style&index=0&id=6565b3c4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565b3c4",
  null
  
)

export default component.exports